import { useQueryApi } from 'utils/api'
import {
  handleError,
  validateStatus,
} from 'api/kinerja/pengawas-sekolah/config'
import { apiPaths, queryKeys } from './config'

import type { TSummary } from 'types/kinerja-tim-penilai-ps'
import type { UseQueryOptions } from 'react-query'

export function useAPIGetSummary({
  periodId,
  ...options
}: UseQueryOptions<TSummary> & { periodId: string }) {
  return useQueryApi<TSummary>(apiPaths.summary(periodId), {
    queryKey: [queryKeys.API_GET_SUMMARY, periodId],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: true,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}
